import React from 'react'
import Link from 'gatsby-link'
import Particles from "./particles";
import Container from "./container";

const Hero = ({ className }) => (
  <div className="hero-area">
    <Particles />
    <Container customClassName="hero-area-container">
      <h1>Business with purpose</h1>
      <p>We are passionately creating digital experiences and engagement for web and mobile <br />through strategy, innovation and dedication.</p>

      <Link to="/contact">
        <div className="button button-white">
          Contact us
        </div>
      </Link>
    </Container>
  </div>
)

export default Hero;



// WEBPACK FOOTER //
// ./src/components/hero.js